import type { Severity } from '@/aiops/utils/dashboard.types';

/**
 * Health Score(0~100, 높을수록 좋음) → Severity 매핑.
 * ≥70 normal / 50~70 warning / <50 critical (전 카드 동일).
 */
export const SCORE_THRESHOLDS = {
  /** 70 이상 normal */
  normal: 70,
  /** 50 이상 70 미만 warning (그 미만은 critical) */
  warning: 50,
} as const;

/**
 * score → severity 단일 진입점. `null`(데이터 미수신)은 `'unknown'` — 상태 미확정을
 * `'critical'`(허위 장애) 이나 `'normal'`(정상 오표기) 로 폴백하지 않는다.
 * NaN·Infinity 도 상태 미확정으로 같이 처리한다 — 비교가 모두 false 가 되어
 * 마지막 `return 'critical'` 로 조용히 떨어지면 미수신이 허위 장애로 표기된다.
 */
export const scoreToSeverity = (score: number | null): Severity => {
  if (score === null || !Number.isFinite(score)) return 'unknown';
  if (score >= SCORE_THRESHOLDS.normal) return 'normal';
  if (score >= SCORE_THRESHOLDS.warning) return 'warning';
  return 'critical';
};
